module.exports = __webpack_public_path__ + "images/emoji/kr.fe112d8a390e798ff3a1.png";